import service from './axios';
export const getPetSpecies = (params = {}) => service.get('/manage/pet-species', { params });
export const createPetSpecies = (d) => service.post('/manage/pet-species', d);
export const updatePetSpecies = (id, d) => service.put(`/manage/pet-species/${id}`, d);
export const deletePetSpecies = (id) => service.delete(`/manage/pet-species/${id}`);
export const getPetBreeds = (params = {}) => service.get('/manage/pet-breeds', { params });
export const createPetBreed = (d) => service.post('/manage/pet-breeds', d);
export const updatePetBreed = (id, d) => service.put(`/manage/pet-breeds/${id}`, d);
export const deletePetBreed = (id) => service.delete(`/manage/pet-breeds/${id}`);
export const getPetArchives = (params = {}) => service.get('/manage/pet-archives', { params });
export const getPetArchive = (id) => service.get(`/manage/pet-archives/${id}`);
export const createPetArchive = (d) => service.post('/manage/pet-archives', d);
export const updatePetArchive = (id, d) => service.put(`/manage/pet-archives/${id}`, d);
export const deletePetArchive = (id) => service.delete(`/manage/pet-archives/${id}`);
export const getPlayRecords = (params = {}) => service.get('/manage/play-records', { params });
export const getPlayRecord = (id) => service.get(`/manage/play-records/${id}`);
export const createPlayRecord = (d) => service.post('/manage/play-records', d);
export const updatePlayRecord = (id, d) => service.put(`/manage/play-records/${id}`, d);
export const deletePlayRecord = (id) => service.delete(`/manage/play-records/${id}`);
